function _enableAnimation() {
  document.body.classList.remove("disable-animated");
}

function _disableAnimation() {
  document.body.classList.add("disable-animated");
}

export default {
  enableAnimation: _enableAnimation,
  disableAnimation: _disableAnimation
};
